// Copyright (c) Move Closer 2022.

import { ShippingMethodCode } from '../../../../contexts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const supportedShippingMethods: string[] = [
  ShippingMethodCode.DHLKurier,
  ShippingMethodCode.Flatrate,
  ShippingMethodCode.Paczkomat,
  ShippingMethodCode.Free,
  ShippingMethodCode.DPDKurier
]

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export function isFreeShipmentThresholdReached (shipments: string[]): boolean {
  return shipments.includes(ShippingMethodCode.Free)
}
